import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Contact } from '../entity/contact';
import { BLService } from './bl.service';

@Injectable()
export class ContactService extends BLService {
  private RESOURCE_ENDPOINT = 'contact';

  saveContact(clientId: number, contact: Contact): Observable<Contact> {
    if (contact.id) {
      return this.updateContact(contact);
    }
    return this.createContact(clientId, contact);
  }

  deleteContact(id: number): Observable<boolean> {
    return this.httpDelete<boolean>(`${this.RESOURCE_ENDPOINT}/${id}`);
  }

  private createContact(clientId: number, contact: Omit<Contact, 'id' | 'clientId'>): Observable<Contact> {
    const body = JSON.stringify(contact);
    return this.httpPost<Contact>(`${this.RESOURCE_ENDPOINT}/${clientId}`, body);
  }

  private updateContact(contact: Contact): Observable<Contact> {
    const body = JSON.stringify(contact);
    return this.httpPut<Contact>(this.RESOURCE_ENDPOINT, body);
  }
}
